// Class: starling.text.TrueTypeCompositor

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
function starling_text_ITextCompositor() {return require("./../../starling/text/ITextCompositor");}
function starling_textures_Texture() {return require("./../../starling/textures/Texture");}
function Std() {return require("./../../Std");}
function starling_utils_SystemUtil() {return require("./../../starling/utils/SystemUtil");}
function starling_utils_MathUtil() {return require("./../../starling/utils/MathUtil");}
function starling_text_BitmapDataEx() {return require("./../../starling/text/BitmapDataEx");}
function openfl_geom_Matrix() {return $import(require("openfl/geom/Matrix"));}
function starling_display_Quad() {return require("./../../starling/display/Quad");}
function openfl_text_TextField() {return $import(require("openfl/text/TextField"));}
function openfl_text_TextFormat() {return $import(require("openfl/text/TextFormat"));}

// Constructor

var TrueTypeCompositor = function() {
}

// Meta

TrueTypeCompositor.__name__ = "starling.text.TrueTypeCompositor";
TrueTypeCompositor.__isInterface__ = false;
TrueTypeCompositor.__interfaces__ = [(starling_text_ITextCompositor().default)];
TrueTypeCompositor.prototype = {
	dispose: function() {
	},
	fillMeshBatch: function(meshBatch,width,height,text,format,options) {
		var _gthis = this;
		if(text == null || text == "") {
			return;
		}
		var textureFormat = options.get_textureFormat();
		var bitmapData = this.renderText(width,height,text,format,options);
		var texture = bitmapData.get_scale();
		var texture1 = (starling_textures_Texture().default).fromBitmapData(bitmapData,false,false,texture,textureFormat);
		texture1.get_root().set_onRestore(function(textureRoot) {
			bitmapData = _gthis.renderText(width,height,text,format,options);
			textureRoot.uploadBitmapData(bitmapData);
			bitmapData.dispose();
			bitmapData = null;
		});
		bitmapData.dispose();
		bitmapData = null;
		TrueTypeCompositor.sHelperQuad.set_texture(texture1);
		TrueTypeCompositor.sHelperQuad.readjustSize();
		if(format.get_horizontalAlign() == "left") {
			TrueTypeCompositor.sHelperQuad.set_x(0);
		} else if(format.get_horizontalAlign() == "center") {
			var tmp = TrueTypeCompositor.sHelperQuad;
			var tmp1 = texture1.get_width();
			tmp.set_x((Std().default).int((width - tmp1) / 2));
		} else {
			var tmp2 = TrueTypeCompositor.sHelperQuad;
			var tmp3 = texture1.get_width();
			tmp2.set_x(width - tmp3);
		}
		if(format.get_verticalAlign() == "top") {
			TrueTypeCompositor.sHelperQuad.set_y(0);
		} else if(format.get_verticalAlign() == "center") {
			var tmp4 = TrueTypeCompositor.sHelperQuad;
			var tmp5 = texture1.get_height();
			tmp4.set_y((Std().default).int((height - tmp5) / 2));
		} else {
			var tmp6 = TrueTypeCompositor.sHelperQuad;
			var tmp7 = texture1.get_height();
			tmp6.set_y(height - tmp7);
		}
		TrueTypeCompositor.sHelperQuad.set_x(TrueTypeCompositor.snapToPixels(TrueTypeCompositor.sHelperQuad.get_x(),options.get_textureScale()));
		TrueTypeCompositor.sHelperQuad.set_y(TrueTypeCompositor.snapToPixels(TrueTypeCompositor.sHelperQuad.get_y(),options.get_textureScale()));
		meshBatch.addMesh(TrueTypeCompositor.sHelperQuad);
		TrueTypeCompositor.sHelperQuad.set_texture(null);
	},
	clearMeshBatch: function(meshBatch) {
		meshBatch.clear();
		if(meshBatch.get_texture() != null) {
			meshBatch.get_texture().dispose();
			meshBatch.set_texture(null);
		}
	},
	getDefaultMeshStyle: function(previousStyle,format,options) {
		return null;
	},
	renderText: function(width,height,text,format,options) {
		var scale = options.get_textureScale();
		var scaledWidth = width * scale;
		var scaledHeight = height * scale;
		var hAlign = format.get_horizontalAlign();
		format.toNativeFormat(TrueTypeCompositor.sNativeFormat);
		TrueTypeCompositor.sNativeFormat.size = (Std().default).int((TrueTypeCompositor.sNativeFormat.size == null ? 0 : TrueTypeCompositor.sNativeFormat.size) * scale);
		TrueTypeCompositor.sNativeTextField.set_embedFonts((starling_utils_SystemUtil().default).isEmbeddedFont(format.get_font(),format.get_bold(),format.get_italic()));
		TrueTypeCompositor.sNativeTextField.set_defaultTextFormat(TrueTypeCompositor.sNativeFormat);
		TrueTypeCompositor.sNativeTextField.set_width(scaledWidth);
		TrueTypeCompositor.sNativeTextField.set_height(scaledHeight);
		TrueTypeCompositor.sNativeTextField.set_antiAliasType("advanced");
		TrueTypeCompositor.sNativeTextField.set_selectable(false);
		TrueTypeCompositor.sNativeTextField.set_multiline(true);
		TrueTypeCompositor.sNativeTextField.set_wordWrap(options.get_wordWrap());
		if(options.get_isHtmlText()) {
			TrueTypeCompositor.sNativeTextField.set_htmlText(text);
		} else {
			TrueTypeCompositor.sNativeTextField.set_text(text);
		}
		if(options.get_autoScale()) {
			TrueTypeCompositor.autoScaleNativeTextField(TrueTypeCompositor.sNativeTextField,text,options.get_isHtmlText());
		}
		var minTextureSize = 1;
		var maxTextureSize = (starling_textures_Texture().default).getMaxSize(options.get_textureFormat());
		var paddingX = options.get_padding() * scale;
		var paddingY = options.get_padding() * scale;
		var textWidth = TrueTypeCompositor.sNativeTextField.get_textWidth() + 4;
		var textHeight = TrueTypeCompositor.sNativeTextField.get_textHeight() + 4;
		var bitmapWidth = (Std().default).int(Math.ceil(textWidth) + 2 * paddingX);
		var bitmapHeight = (Std().default).int(Math.ceil(textHeight) + 2 * paddingY);
		if(bitmapWidth > scaledWidth) {
			paddingX = (starling_utils_MathUtil().default).max(0,(scaledWidth - textWidth) / 2);
			bitmapWidth = Math.ceil(scaledWidth);
		}
		if(bitmapHeight > scaledHeight) {
			paddingY = (starling_utils_MathUtil().default).max(0,(scaledHeight - textHeight) / 2);
			bitmapHeight = Math.ceil(scaledHeight);
		}
		if(options.get_isHtmlText()) {
			bitmapWidth = (Std().default).int(scaledWidth);
			textWidth = bitmapWidth;
		}
		if(bitmapWidth < minTextureSize) {
			bitmapWidth = 1;
		}
		if(bitmapHeight < minTextureSize) {
			bitmapHeight = 1;
		}
		if(bitmapHeight > maxTextureSize || bitmapWidth > maxTextureSize) {
			var _g = options;
			_g.set_textureScale(_g.get_textureScale() * (maxTextureSize / Math.max(bitmapWidth,bitmapHeight)));
			return this.renderText(width,height,text,format,options);
		} else {
			var offsetX = -paddingX;
			var offsetY = -paddingY;
			if(!options.get_isHtmlText()) {
				if(hAlign == "right") {
					offsetX = scaledWidth - textWidth - paddingX;
				} else if(hAlign == "center") {
					offsetX = (scaledWidth - textWidth) / 2.0 - paddingX;
				}
			}
			var bitmapData = new (starling_text_BitmapDataEx().default)(bitmapWidth,bitmapHeight);
			TrueTypeCompositor.sHelperMatrix.setTo(1,0,0,1,-offsetX,-offsetY);
			bitmapData.draw(TrueTypeCompositor.sNativeTextField,TrueTypeCompositor.sHelperMatrix);
			bitmapData.set_scale(scale);
			TrueTypeCompositor.sNativeTextField.set_text("");
			return bitmapData;
		}
	}
};
TrueTypeCompositor.prototype.__class__ = TrueTypeCompositor.prototype.constructor = $hxClasses["starling.text.TrueTypeCompositor"] = TrueTypeCompositor;

// Init



// Statics

TrueTypeCompositor.autoScaleNativeTextField = function(textField,text,isHtmlText) {
	var textFormat = textField.get_defaultTextFormat();
	var maxTextWidth = (Std().default).int(textField.get_width()) - 4;
	var maxTextHeight = (Std().default).int(textField.get_height()) - 4;
	var size = textFormat.size == null ? 0 : textFormat.size;
	while(textField.get_textWidth() > maxTextWidth || textField.get_textHeight() > maxTextHeight) {
		if(size <= 4) {
			break;
		}
		textFormat.size = (Std().default).int(size--);
		textField.set_defaultTextFormat(textFormat);
		if(isHtmlText) {
			textField.set_htmlText(text);
		} else {
			textField.set_text(text);
		}
	}
}
TrueTypeCompositor.snapToPixels = function(coordinate,scaleFactor) {
	if(coordinate == 0.0 || scaleFactor == 0.0) {
		return coordinate;
	} else {
		var pixelSize = 1.0 / scaleFactor;
		return Math.round(coordinate / pixelSize) * pixelSize;
	}
}
TrueTypeCompositor.sHelperMatrix = new (openfl_geom_Matrix().default)()
TrueTypeCompositor.sHelperQuad = new (starling_display_Quad().default)(100,100)
TrueTypeCompositor.sNativeTextField = new (openfl_text_TextField().default)()
TrueTypeCompositor.sNativeFormat = new (openfl_text_TextFormat().default)()

// Export

exports.default = TrueTypeCompositor;